import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { SET_LOADING } from "../redux/action-types";
import theme from "../theme/theme";
import Button from "./Base/Button";
import { analytics } from "../analytics";

const StepperComponent = styled.div`
  // position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px 0;
  gap: 80px;
  width: 100%;
  box-sizing: border-box;
  overflow: scroll;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,
    rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
  background-color: ${theme.colors.bg};
  .stepperSelectorWrapper {
    height: 100%;
    overflow-x: hidden;
  }

  @media (max-width: 480px) {
    padding: 2% 0%;
    min-height: 670px;
    overflow-y: scroll;
  }

  @media (max-width: 1076px) and (min-width: 481px) {
    padding: 2% 0%;
    min-height: 790px;
  }
`;

const StepperSelector = styled.div`
  display: inline-flex;
  /* Animate each step movement */
  transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1) 0s;
  align-items: flex-start;

  @media (max-width: 480px) {
    top: 3%;
  }
`;

const StepWrapper = styled.div`
  width: 100vw;
  display: flex;
  justify-content: center;

  @media (max-width: 480px) {
    padding-right: 2%;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: auto;
  margin-bottom: 20px;

  > div {
    display: flex;
    justify-content: space-between;
    margin: auto;
    max-width: 1076px;
  }

  button {
    padding: 20px 60px;
  }

  > div {
    @media (max-width: 480px) {
      display: block;
      padding: 0% 5%;

      button {
        order: 2;
        padding: 4% 0%;
        font-size: 12px;
      }
    }
  }

  @media (max-width: 480px) {
    .buttonSecondaryWrapper {
      display: flex;
      flex-direction: column;
    }
  }

  @media (max-width: 1075px) {
    .buttonSecondaryWrapper {
      padding: 2% 5%;
    }
  }
`;

const NextButton = styled(Button)`
  @media (max-width: 480px) {
    order: 1 !important;
  }

  &:not(:disabled) {
    background-color: ${theme.colors.primaryStrong};
  }
`;

const Stepper = ({ steps, showPrevNext }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
  const [nextAction, setNextAction] = useState(null);
  const stepperSelector = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const { goal } = useSelector((state) => state.user);
  // Every time our currentStep is updated, we are going to trigger this
  useEffect(() => {
    const moveStepper = () => {
      if (stepperSelector.current) {
        const stepper = stepperSelector.current;
        const stepWidth = stepper.offsetWidth / steps.length;
        stepper.style.transform = `translateX(-${
          stepWidth * (currentStep - 1)
        }px)`;
      }
    };

    moveStepper();
  }, [steps.length, currentStep]);

  const goPreviousStep = () => {
    const previousStep = currentStep - 1;
    if (previousStep >= 1) {
      setCurrentStep(previousStep);
      setNextBtnDisabled(false);
    } else {
      history.push("/strategy-screen");
    }
  };

  const goNextStep = async () => {
    dispatch({ type: SET_LOADING, payload: true });
    if (nextAction) {
      const isError = await nextAction();
      if (isError?.message) {
        dispatch({ type: SET_LOADING, payload: false });
        return;
      } else {
        dispatch({ type: SET_LOADING, payload: false });
        const nextStep = currentStep + 1;
        if (nextStep <= steps.length) {
          setCurrentStep(nextStep);
          setNextBtnDisabled(true);
        } else {
          dispatch({ type: SET_LOADING, payload: true });
          const currentDateTime = new Date();
          analytics.track("Questionnaire Completed", {
            goalId: goal?.id || "",
            goalType: goal?.type || "",
            questionnaireUpdated: currentDateTime.toLocaleString(),
          });
          history.push("/dashboard");
        }
      }
    }
  };

  return (
    <>
      <StepperComponent>
        <div className="stepperSelectorWrapper">
          <StepperSelector ref={stepperSelector}>
            {steps.map((step, i) => (
              <StepWrapper key={i}>
                <step.element
                  setNextBtnDisabled={setNextBtnDisabled}
                  setNextAction={setNextAction}
                  step={i + 1}
                  goNextStep={goNextStep}
                  goPreviousStep={goPreviousStep}
                  // From our state
                  currentStep={currentStep}
                  // Check if this step is the first one
                  isFirst={i === 0}
                  // Check if its the last one
                  isLast={i === steps.length - 1}
                />
              </StepWrapper>
            ))}
          </StepperSelector>
        </div>
        {showPrevNext && (
          <ButtonWrapper>
            <div className="buttonSecondaryWrapper">
              <Button secondary onClick={goPreviousStep}>
                BACK
              </Button>
              <NextButton
                primary
                disabled={nextBtnDisabled}
                onClick={goNextStep}
              >
                NEXT
              </NextButton>
            </div>
          </ButtonWrapper>
        )}
      </StepperComponent>
    </>
  );
};

export default Stepper;
